/* =================================================================
   Bundle Page Detector — adds body.fbp-power-stack on Power Stack
   product pages and body.fbp-lever-belt on Lever Belt product pages
   so CSS can be scoped to only show the Fast Bundle widget on the
   two intended bundle pages and hide it everywhere else.

   Also, as early as this script runs, injects a synchronous <style>
   element that hides `.price__regular` until it has been marked
   `.hb-price-ready`. External stylesheets (theme.css, the Fast
   Bundle app CSS) may not have applied yet at first paint on slow
   loads, so a same-tag inline style is the fastest reliable way to
   prevent the belt-only base price from ever showing on screen. The
   Top Price Preempt IIFE at the bottom of this file adds
   `.hb-price-ready` once the correct bundle total is in place.
   ================================================================= */
(function () {
  "use strict";

  // Inject the "hide until ready" style FIRST, before we even touch
  // the body class. This is safe even before body exists — <style>
  // in <head> applies from the moment it's parsed. Idempotent.
  function injectPriceHideStyle() {
    if (document.getElementById('hb-price-hide-style')) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return;
    var s = document.createElement('style');
    s.id = 'hb-price-hide-style';
    // Hide top price on lever belt pages until JS confirms the bundle
    // total is in place. We match two ways:
    //   1) body.fbp-lever-belt — normal path once markBundleType() runs
    //   2) html[data-hb-lever-belt] — set below BEFORE body class in
    //      case a race causes the CSS to be evaluated before body
    //      class is toggled.
    // visibility (not display) so the layout box is preserved and
    // Add-to-Cart doesn't jump when the price becomes visible.
    s.textContent =
      'body.fbp-lever-belt .product__price .price__regular:not(.hb-price-ready),' +
      'html[data-hb-lever-belt] .product__price .price__regular:not(.hb-price-ready){' +
      'visibility:hidden !important;}';
    head.appendChild(s);
  }

  // Best-effort synchronous detection of "is this a lever belt page?"
  // at script-parse time, so we can flip an html attribute BEFORE
  // the body class is available. Uses <title> and any early-parsed
  // <h1> if present. Safe to run repeatedly.
  function earlyMarkLeverBelt() {
    var root = document.documentElement;
    if (root.hasAttribute('data-hb-lever-belt')) return;
    var titleTxt = (document.title || '');
    var h1 = document.querySelector('h1, .product__title, [class*="product-title"]');
    var h1Txt = h1 ? (h1.textContent || '') : '';
    var text = titleTxt + ' ' + h1Txt;
    if (/lever\s*belt/i.test(text) && !/power\s*stack/i.test(text)) {
      root.setAttribute('data-hb-lever-belt', '');
    }
  }

  function markBundleType() {
    var t = document.querySelector('.product__title, [class*="product-title"], h1');
    if (!t) return;
    var text = t.textContent || '';
    if (/power\s*stack/i.test(text)) {
      document.body.classList.add('fbp-power-stack');
      // Power Stack is NOT a lever belt page — clear any early marker.
      document.documentElement.removeAttribute('data-hb-lever-belt');
    }
    if (/lever\s*belt/i.test(text) && !/power\s*stack/i.test(text)) {
      document.body.classList.add('fbp-lever-belt');
    }
  }

  // Run inject + early mark IMMEDIATELY (before body exists is fine).
  injectPriceHideStyle();
  earlyMarkLeverBelt();

  if (document.body) {
    markBundleType();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      // Re-inject in case <head> only became available now.
      injectPriceHideStyle();
      earlyMarkLeverBelt();
      markBundleType();
    });
  }
})();


/* =================================================================
   Fast Bundle · Lever Section "Radio Button" Behavior   (v2)
   Berlin Theme · Mix & Match Lever Belt Bundle
   -----------------------------------------------------------------
   PURPOSE
   Fast Bundle caps the levers section at 1 item, so clicking a
   second lever silently fails. This snippet intercepts clicks
   inside the lever section and, if another lever is already
   selected, removes the old one, waits for the widget to
   re-render, then programmatically adds the new lever.
   -----------------------------------------------------------------
   WHAT'S NEW IN v2
   1. Fires a full mousedown/mouseup/click sequence on the minus
      button (not just .click()), so Fast Bundle's React handlers
      reliably fire.
   2. preventDefault() on the user's pointerdown to stop Fast
      Bundle from trying to add-before-remove.
   3. MutationObserver-based wait loop so we only trigger the new
      add once the widget has actually re-rendered.
   4. Programmatically dispatches a `change` event on the new
      lever's <select> so the native dropdown never has to open.
   -----------------------------------------------------------------
   SAFE INSTALL — DO NOT EDIT theme.js

   1. Shopify admin → Online Store → Themes → Edit code
   2. Assets → Add a new asset → Create blank file: `custom.js`
   3. Paste this entire file into custom.js and save.
   4. Open `layout/theme.liquid`. Just before `</body>`, add:
         {{ 'custom.js' | asset_url | script_tag }}
      Save. Hard-refresh the storefront.
   ================================================================= */

(function () {
  "use strict";

  var WIDGET_ID = "rbr-container-element-true";
  var FLAG = "__fbpLeverRadioInstalled";
  var SOLD_OUT_CLASS = "fbp-sold-out";
  var DEBUG = true; // temporarily on while we verify the belt size grid

  // ---------- PER-TEMPLATE CONFIG ----------
  // On the Lever Belt product pages the belt is predetermined (one belt
  // per product/color), so we want the widget to start with that belt
  // already added to the bundle. Set to `false` on templates where the
  // user should actively choose their belt (e.g. Power Stacks).
  var AUTO_SELECT_BELT = true;

  // Auto-select the FIRST available lever on page load so the bundle
  // is "ready to add to cart" the moment the page renders. This is a
  // UX fix: Fast Bundle hides the "Add to cart" button until at least
  // one lever is added, which can read as a broken page on arrival.
  // Pre-selecting the first lever surfaces the button immediately.
  // The user can still click a different lever — the existing radio-
  // swap behavior in onPointerDown handles that swap correctly.
  var AUTO_SELECT_LEVER = true;

  // Render a custom "box swatch" size grid for the belt (replacing Fast
  // Bundle's native <select> dropdown). Tied to AUTO_SELECT_BELT logic
  // and the CSS rules that hide the belt image + native size selector.
  var BELT_SIZE_GRID = true;
  var SIZE_GRID_CLASS = "fbp-size-grid";
  var SIZE_BOX_CLASS = "fbp-size-box";
  var SIZE_BOX_SELECTED = "fbp-size-box--selected";
  var SIZE_BOX_SOLDOUT = "fbp-size-box--sold-out";

  // Idempotency
  if (window[FLAG]) return;
  window[FLAG] = true;

  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ["[fbp-radio]"].concat([].slice.call(arguments)));
    }
  }

  /**
   * Locate the levers accordion by title, not by index.
   *
   * WHY: Bundles vary in size. The standalone Mix & Match Lever Belt has
   * 2 sections (belt + levers) so dividers[1] was the levers. Bundles
   * like the Power Stack have 4 sections (belt + knee sleeves + wrist
   * wraps + levers), where dividers[1] is actually knee sleeves.
   * Hardcoding an index misidentifies the lever section on any bundle
   * that isn't the exact 2-section layout.
   *
   * HEURISTIC: Match an accordion title that contains "LEVER" but NOT
   * "LEVER BELT". Current bundle section titles satisfy this:
   *   - "10 MM LEVERS" ✓
   *   - "Lever Belt"   ✗ (excluded)
   * Falls back to the second divider only if no title match is found,
   * preserving legacy behavior for any edge case.
   */
  function getLeverSection() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return null;
    var dividers = widget.querySelectorAll('[class*="MainSection_divider"]');
    for (var i = 0; i < dividers.length; i++) {
      var titleEl = dividers[i].querySelector('[class*="accordionHead_productTitle"]');
      var title = titleEl ? (titleEl.textContent || "").trim() : "";
      if (/lever/i.test(title) && !/lever\s*belt/i.test(title)) {
        return dividers[i];
      }
    }
    return dividers[1] || null;
  }

  /**
   * Fire a full native-feeling click on an element. Plain
   * element.click() only dispatches "click" — React components
   * that listen for mousedown/pointerdown need the full sequence.
   */
  function simulateFullClick(el) {
    if (!el) return;
    var opts = { bubbles: true, cancelable: true, view: window, button: 0 };
    try { el.dispatchEvent(new PointerEvent("pointerdown", opts)); } catch (_) {}
    el.dispatchEvent(new MouseEvent("mousedown", opts));
    try { el.dispatchEvent(new PointerEvent("pointerup", opts)); } catch (_) {}
    el.dispatchEvent(new MouseEvent("mouseup", opts));
    el.dispatchEvent(new MouseEvent("click", opts));
  }

  /**
   * Invoke a React element's onClick handler directly via its
   * __reactProps — bypasses event dispatch entirely. Used as a
   * belt-and-suspenders remove mechanism alongside simulateFullClick,
   * because Fast Bundle's belt-size SVL can persist in-place when
   * simulated events race with our subsequent change-event for the
   * new variant.
   */
  function invokeReactOnClick(el) {
    if (!el) return false;
    var keys = Object.keys(el);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf("__reactProps") !== 0) continue;
      var props = el[keys[i]];
      if (!props || typeof props.onClick !== "function") continue;
      try {
        props.onClick({
          preventDefault: function () {},
          stopPropagation: function () {},
          target: el,
          currentTarget: el,
          nativeEvent: null,
          bubbles: true,
          cancelable: true
        });
        return true;
      } catch (_) {
        return false;
      }
    }
    return false;
  }

  /**
   * Dispatch a change event on a <select> in the way React
   * expects. Setting .value alone doesn't trigger React's
   * synthetic handler because React tracks the input's
   * "value tracker" internally.
   */
  function setSelectValueReactSafe(selectEl, value) {
    if (!selectEl) return;
    var proto = window.HTMLSelectElement && window.HTMLSelectElement.prototype;
    var setter = proto && Object.getOwnPropertyDescriptor(proto, "value") && Object.getOwnPropertyDescriptor(proto, "value").set;
    if (setter) {
      setter.call(selectEl, value);
    } else {
      selectEl.value = value;
    }
    selectEl.dispatchEvent(new Event("input", { bubbles: true }));
    selectEl.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /**
   * Wait until the currently-selected lever has been removed
   * from the DOM (its SelectedVariantsList disappears), then
   * invoke cb(). Bails out after ~1s to avoid hanging.
   */
  function waitForRemoval(leverSection, cb) {
    var start = Date.now();
    var TIMEOUT = 1000;

    function check() {
      var stillThere = leverSection.querySelector('[class*="SelectedVariantsList"]');
      if (!stillThere) {
        log("old lever removed after", Date.now() - start, "ms");
        cb();
        return true;
      }
      return false;
    }

    if (check()) return;

    var obs = new MutationObserver(function () {
      if (check()) obs.disconnect();
    });
    obs.observe(leverSection, { childList: true, subtree: true });

    // Safety net if mutation never fires
    setTimeout(function () {
      obs.disconnect();
      log("timeout waiting for removal; firing add anyway");
      cb();
    }, TIMEOUT);
  }

  /**
   * Scan the entire widget and mark truly sold-out tiles with a
   * marker class. A tile is sold out when its variantSelector slot
   * is rendered as a <div data-disabled="true"> whose visible text
   * contains "Sold out". We must do this in JS because Fast Bundle
   * reuses data-disabled="true" for many states (selected, at-max,
   * genuinely sold out) and CSS can't inspect text content.
   */
  function scanForSoldOut() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;
    var tiles = widget.querySelectorAll(
      '[class*="style_collectionItems"] > [class*="style_container"]'
    );
    for (var i = 0; i < tiles.length; i++) {
      var tile = tiles[i];
      var vs = tile.querySelector('[class*="variantSelector"]');
      var soldOut =
        !!vs &&
        vs.tagName === "DIV" &&
        vs.getAttribute("data-disabled") === "true" &&
        /sold\s*out/i.test((vs.textContent || "").trim());
      if (soldOut) {
        tile.classList.add(SOLD_OUT_CLASS);
      } else {
        tile.classList.remove(SOLD_OUT_CLASS);
      }
    }
  }

  /**
   * Auto-select the belt tile on the Lever Belt product template.
   *
   * IMPORTANT DESIGN CHOICE: this function runs AT MOST ONCE per page
   * load. After it successfully auto-adds the belt — OR detects that
   * the belt is already selected — it sets `_beltAutoSelectDone` and
   * becomes a permanent no-op for the rest of the session. This is
   * what prevents the "can't delete levers, price keeps going up"
   * regression we hit before: if the function kept re-firing on every
   * DOM mutation, any deselection triggered an immediate re-add.
   *
   * Safety guard: if the widget doesn't have at least two bundle
   * sections (belt + levers), we assume we're on an unfamiliar
   * template and bail out without touching anything.
   */
  var _beltAutoSelectDone = false;
  var _beltHealthLogged = false;
  function autoSelectBeltOnce() {
    if (_beltAutoSelectDone) return;
    if (!AUTO_SELECT_BELT) return;

    var widget = document.getElementById(WIDGET_ID);
    if (!widget) { if (!_beltHealthLogged) { log("belt/health: widget missing"); _beltHealthLogged = true; } return; }

    var dividers = widget.querySelectorAll('[class*="MainSection_divider"]');
    if (dividers.length < 2) {
      if (!_beltHealthLogged) { log("belt/health: dividers=", dividers.length); _beltHealthLogged = true; }
      return;
    }

    var beltSection = dividers[0];

    // Already selected? Mark done so we don't interfere with user actions.
    if (beltSection.querySelector('[class*="SelectedVariantsList"]')) {
      log("belt/health: already selected on arrival; marking done");
      _beltAutoSelectDone = true;
      return;
    }

    var firstTile = beltSection.querySelector(
      '[class*="style_collectionItems"] > [class*="style_container"]'
    );
    if (!firstTile) {
      if (!_beltHealthLogged) {
        log("belt/health: no tile found. beltSection HTML head:",
          beltSection.outerHTML.slice(0, 300));
        _beltHealthLogged = true;
      }
      return;
    }

    var select = firstTile.querySelector(
      'select[class*="variantSelector_container"]'
    ) || firstTile.querySelector("select");
    if (!select) {
      if (!_beltHealthLogged) {
        log("belt/health: tile found but no <select>. tile HTML head:",
          firstTile.outerHTML.slice(0, 400));
        _beltHealthLogged = true;
      }
      return;
    }

    // Skip the hidden "add" placeholder; pick the first real variant option.
    var optionToPick = null;
    for (var j = 0; j < select.options.length; j++) {
      var opt = select.options[j];
      if (opt.value && opt.value !== "add") {
        optionToPick = opt;
        break;
      }
    }
    if (!optionToPick) {
      if (!_beltHealthLogged) {
        log("belt/health: <select> present but no real options. options:",
          Array.prototype.map.call(select.options, function (o) {
            return { v: o.value, t: o.text, d: o.disabled };
          }));
        _beltHealthLogged = true;
      }
      return;
    }

    setSelectValueReactSafe(select, optionToPick.value);
    _beltAutoSelectDone = true;
    log("auto-selected belt:", optionToPick.value);
  }

  /**
   * Auto-select the first available lever on page load.
   *
   * Mirrors autoSelectBeltOnce: runs AT MOST ONCE per page load and
   * becomes a permanent no-op once it has succeeded — OR once a lever
   * is detected as already selected. Without that one-shot guarantee,
   * any user de-selection would be re-added on the next mutation tick.
   *
   * Picks the FIRST non-sold-out tile and adds it to the bundle using
   * the same multi-path logic as the lever click handler:
   *   1. Drive the tile's <select> if one exists (variant-style lever).
   *   2. Otherwise invoke a React onClick on a descendant or the tile
   *      itself (non-variant lever — Fast Bundle's typical render).
   *   3. Last resort: simulate a full click sequence on the tile.
   *
   * Safety guard: if the lever section isn't present yet, or has no
   * tiles, we bail and let scheduleRescan re-run us once tiles render.
   */
  var _leverAutoSelectDone = false;
  var _leverHealthLogged = false;
  function autoSelectLeverOnce() {
    if (_leverAutoSelectDone) return;
    if (!AUTO_SELECT_LEVER) return;

    var leverSection = getLeverSection();
    if (!leverSection) {
      if (!_leverHealthLogged) { log("lever/health: section missing"); _leverHealthLogged = true; }
      return;
    }

    // If a lever is already selected, mark done so we don't fight the user.
    if (leverSection.querySelector('[class*="SelectedVariantsList"]')) {
      log("lever/health: already selected on arrival; marking done");
      _leverAutoSelectDone = true;
      return;
    }

    var tiles = leverSection.querySelectorAll(
      '[class*="style_collectionItems"] > [class*="style_container"]'
    );
    if (!tiles.length) {
      if (!_leverHealthLogged) {
        log("lever/health: no tiles found yet");
        _leverHealthLogged = true;
      }
      return;
    }

    // Pick the first non-sold-out tile. SOLD_OUT_CLASS is set by
    // scanForSoldOut(), which always runs in the same rescan pass
    // BEFORE this function — so the marker class is up to date.
    var firstTile = null;
    for (var i = 0; i < tiles.length; i++) {
      if (!tiles[i].classList.contains(SOLD_OUT_CLASS)) {
        firstTile = tiles[i];
        break;
      }
    }
    if (!firstTile) {
      if (!_leverHealthLogged) {
        log("lever/health: all levers sold out; nothing to auto-select");
        _leverHealthLogged = true;
      }
      return;
    }

    // Path 1: tile has a real <select> with variants — drive it.
    var select =
      firstTile.querySelector('select[class*="variantSelector_container"]') ||
      firstTile.querySelector("select");
    if (select && select.options && select.options.length) {
      var optionToPick = null;
      for (var j = 0; j < select.options.length; j++) {
        var opt = select.options[j];
        if (opt.value && opt.value !== "add") {
          optionToPick = opt;
          break;
        }
      }
      if (optionToPick) {
        setSelectValueReactSafe(select, optionToPick.value);
        _leverAutoSelectDone = true;
        log("auto-selected lever via <select>:", optionToPick.value);
        return;
      }
    }

    // Path 2: invoke React's onClick on the most specific descendant
    // first (typically the inner "add" button), falling back to the
    // tile itself. Same single-invocation rule as onPointerDown's
    // first-time-add path — invoking more than one onClick can cause
    // Fast Bundle to add the variant multiple times.
    var invokedEl = null;
    var cands = firstTile.querySelectorAll("*");
    for (var k = 0; k < cands.length; k++) {
      if (invokeReactOnClick(cands[k])) {
        invokedEl = cands[k];
        break;
      }
    }
    if (!invokedEl && invokeReactOnClick(firstTile)) invokedEl = firstTile;

    if (invokedEl) {
      _leverAutoSelectDone = true;
      log(
        "auto-selected lever via React onClick on",
        invokedEl.tagName +
          (invokedEl.className
            ? " ." + (invokedEl.className + "").split(" ")[0]
            : "")
      );
      return;
    }

    // Path 3: simulate a full native click on the tile as last resort.
    // Wrapped in _simulating guard so our onPointerDown capture handler
    // doesn't re-enter and double-fire.
    _simulating = true;
    try {
      simulateFullClick(firstTile);
    } finally {
      setTimeout(function () { _simulating = false; }, 0);
    }
    _leverAutoSelectDone = true;
    log("auto-selected lever via simulated click on tile");
  }

  // ======================================================================
  // BELT SIZE BOX GRID
  // ----------------------------------------------------------------------
  // We inject a custom grid of "box" size swatches into the belt tile and
  // hide Fast Bundle's native <select> (via CSS). Clicks on a box drive
  // the hidden <select> using the same React-safe value setter we use
  // elsewhere. Sold-out sizes are detected from <option disabled> and/or
  // a "Sold out" substring in the option text.
  //
  // The options list is CACHED on first sight, because once the belt has
  // been added to the bundle Fast Bundle may re-render the tile in ways
  // that move the <select> around. Caching lets us keep rendering a
  // correct grid regardless of the tile's visual state.
  // ======================================================================

  var _beltSizeCache = null; // [{value, displayText, soldOut}]

  /**
   * Return the belt tile (or null if we can't find it / aren't on the
   * lever-belt template).
   */
  function getBeltTile() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return null;
    var dividers = widget.querySelectorAll('[class*="MainSection_divider"]');
    if (dividers.length < 2) return null;
    var beltSection = dividers[0];
    return beltSection.querySelector(
      '[class*="style_collectionItems"] > [class*="style_container"]'
    );
  }

  /**
   * Find the belt's <select> anywhere inside the belt tile — Fast Bundle
   * may nest it differently before vs after the belt has been added.
   */
  function getBeltSelect(tile) {
    if (!tile) return null;
    return (
      tile.querySelector('select[class*="variantSelector_container"]') ||
      tile.querySelector("select")
    );
  }

  /**
   * Read the variant options from a belt <select> into a normalized
   * array, skipping the hidden "add" placeholder. Detects sold-out both
   * from option.disabled and from a "Sold out" substring in the text.
   */
  function readBeltSizes(select) {
    var out = [];
    if (!select) return out;
    for (var i = 0; i < select.options.length; i++) {
      var o = select.options[i];
      if (!o.value || o.value === "add") continue;
      var raw = (o.text || "").trim();
      var soldOut =
        !!o.disabled ||
        /sold\s*out/i.test(raw) ||
        /sold\s*out/i.test(o.getAttribute("data-label") || "");
      // Strip a trailing " - Sold out" (or similar) from the display.
      var displayText = raw
        .replace(/\s*[-–—]\s*sold\s*out\s*$/i, "")
        .replace(/\s*\(\s*sold\s*out\s*\)\s*$/i, "")
        .trim();
      out.push({
        value: o.value,
        displayText: displayText,
        soldOut: soldOut
      });
    }
    return out;
  }

  /**
   * Build (or update) the size-box grid inside the belt tile.
   * Idempotent: safe to call on every rescan.
   */
  function updateBeltSizeGrid() {
    if (!BELT_SIZE_GRID) return;
    var tile = getBeltTile();
    if (!tile) return;

    var select = getBeltSelect(tile);

    // Seed/refresh the cache whenever we can see real options.
    if (select) {
      var fresh = readBeltSizes(select);
      if (fresh.length) _beltSizeCache = fresh;
    }
    if (!_beltSizeCache) return; // nothing to render yet

    // Determine the currently-selected value. Prefer the live select;
    // fall back to matching the SelectedVariantsList title text.
    var currentValue = select ? select.value : "";
    if (!currentValue || currentValue === "add") {
      var selectedTitle = tile.querySelector(
        '[class*="SelectedVariantsList_title"]'
      );
      if (selectedTitle) {
        var titleText = (selectedTitle.textContent || "").trim();
        for (var m = 0; m < _beltSizeCache.length; m++) {
          if (_beltSizeCache[m].displayText === titleText) {
            currentValue = _beltSizeCache[m].value;
            break;
          }
        }
      }
    }

    // Find or create the grid container.
    var grid = tile.querySelector("." + SIZE_GRID_CLASS);
    if (!grid) {
      grid = document.createElement("div");
      grid.className = SIZE_GRID_CLASS;

      var header = document.createElement("div");
      header.className = "fbp-size-grid__header";
      // On Power Stack the bundle has multiple size selectors (belt +
      // knee sleeves + wrist wraps), so disambiguate the belt row.
      // The body.fbp-power-stack class is set by the preamble IIFE at
      // the top of this file — by the time this runs it's already on.
      var beltHeaderLabel = document.body.classList.contains("fbp-power-stack")
        ? "Lever Belt Size: "
        : "Size: ";
      header.appendChild(document.createTextNode(beltHeaderLabel));
      var headerValue = document.createElement("span");
      headerValue.className = "fbp-size-grid__current";
      header.appendChild(headerValue);

      var boxes = document.createElement("div");
      boxes.className = "fbp-size-grid__boxes";

      grid.appendChild(header);
      grid.appendChild(boxes);
      tile.appendChild(grid);
    }

    // Update the "Size: <name>" header.
    var headerValueEl = grid.querySelector(".fbp-size-grid__current");
    var currentDisplay = "";
    for (var n = 0; n < _beltSizeCache.length; n++) {
      if (_beltSizeCache[n].value === currentValue) {
        currentDisplay = _beltSizeCache[n].displayText;
        break;
      }
    }
    var nextHeaderText = currentDisplay || "Select one";
    if (headerValueEl.textContent !== nextHeaderText) {
      headerValueEl.textContent = nextHeaderText;
    }

    // Rebuild the boxes (simple approach — cheap, and sold-out state
    // can change between rescans).
    var boxesEl = grid.querySelector(".fbp-size-grid__boxes");
    boxesEl.innerHTML = "";
    for (var k = 0; k < _beltSizeCache.length; k++) {
      var item = _beltSizeCache[k];
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = SIZE_BOX_CLASS;
      btn.setAttribute("data-value", item.value);
      btn.textContent = item.displayText;
      if (item.soldOut) {
        btn.classList.add(SIZE_BOX_SOLDOUT);
        btn.setAttribute("aria-disabled", "true");
        btn.title = "Sold out";
      }
      if (item.value === currentValue) {
        btn.classList.add(SIZE_BOX_SELECTED);
        btn.setAttribute("aria-pressed", "true");
      }
      boxesEl.appendChild(btn);
    }
  }

  // ======================================================================
  // ACCESSORY SIZE GRIDS (Power Stack: knee sleeves + wrist wraps)
  // ----------------------------------------------------------------------
  // Any bundle section that is NEITHER the belt (dividers[0]) NOR the
  // levers (title-matched via getLeverSection) is treated as an
  // accessory. We render the same size-box grid used by the belt, so
  // the visual + interaction model is consistent across every section.
  //
  // On the standalone Lever Belt page there are only 2 sections so this
  // loop is a no-op. On Power Stack it fires for knee sleeves + wrist
  // wraps.
  //
  // Cache is stored per-section on the element itself (`_fbpSizes`) to
  // survive Fast Bundle re-renders that briefly remove the <select>.
  // ======================================================================

  function getAccessorySections() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return [];
    var dividers = widget.querySelectorAll('[class*="MainSection_divider"]');
    if (dividers.length < 3) return []; // Lever Belt has only 2 → no accessories
    var leverSection = getLeverSection();
    var out = [];
    for (var i = 0; i < dividers.length; i++) {
      if (i === 0) continue;              // skip belt
      if (dividers[i] === leverSection) continue; // skip levers
      out.push(dividers[i]);
    }
    return out;
  }

  function getAccessoryTile(section) {
    if (!section) return null;
    return section.querySelector(
      '[class*="style_collectionItems"] > [class*="style_container"]'
    );
  }

  function updateSizeGridInAccessoryTile(section) {
    var tile = getAccessoryTile(section);
    if (!tile) return;

    // Tag the tile so CSS Section 24 can flatten it + hide native
    // <select> and image. Idempotent.
    if (!tile.hasAttribute("data-fbp-accessory-tile")) {
      tile.setAttribute("data-fbp-accessory-tile", "1");
    }

    var select =
      tile.querySelector('select[class*="variantSelector_container"]') ||
      tile.querySelector("select");

    // Seed/refresh the per-section cache when we can see real options.
    if (select) {
      var fresh = readBeltSizes(select); // same shape as belt sizes
      if (fresh.length) section._fbpSizes = fresh;
    }
    var cache = section._fbpSizes;
    if (!cache) return;

    // Determine the currently-selected value.
    var currentValue = select ? select.value : "";
    if (!currentValue || currentValue === "add") {
      var selectedTitle = tile.querySelector(
        '[class*="SelectedVariantsList_title"]'
      );
      if (selectedTitle) {
        var titleText = (selectedTitle.textContent || "").trim();
        for (var m = 0; m < cache.length; m++) {
          if (cache[m].displayText === titleText) {
            currentValue = cache[m].value;
            break;
          }
        }
      }
    }

    // Read the accordion header title so we can label the grid nicely
    // (e.g. "Knee Sleeves: XS"). Fallback to "Size" if not readable.
    var accordionTitleEl = section.querySelector(
      '[class*="accordionHead_productTitle"]'
    );
    var labelBase = accordionTitleEl
      ? (accordionTitleEl.textContent || "").trim()
      : "";
    // Trim quantity prefixes like "1 x " if Fast Bundle adds them.
    labelBase = labelBase.replace(/^\d+\s*[xX×]\s*/, "").trim();
    if (!labelBase) labelBase = "Size";

    // Find or create the grid container.
    var grid = tile.querySelector("." + SIZE_GRID_CLASS);
    if (!grid) {
      grid = document.createElement("div");
      grid.className = SIZE_GRID_CLASS;

      var header = document.createElement("div");
      header.className = "fbp-size-grid__header";
      header.appendChild(document.createTextNode(labelBase + ": "));
      var headerValue = document.createElement("span");
      headerValue.className = "fbp-size-grid__current";
      header.appendChild(headerValue);

      var boxes = document.createElement("div");
      boxes.className = "fbp-size-grid__boxes";

      grid.appendChild(header);
      grid.appendChild(boxes);
      tile.appendChild(grid);
    }

    // Update header current value.
    var headerValueEl = grid.querySelector(".fbp-size-grid__current");
    var currentDisplay = "";
    for (var n = 0; n < cache.length; n++) {
      if (cache[n].value === currentValue) {
        currentDisplay = cache[n].displayText;
        break;
      }
    }
    var nextHeaderText = currentDisplay || "Select one";
    if (headerValueEl.textContent !== nextHeaderText) {
      headerValueEl.textContent = nextHeaderText;
    }

    // Rebuild boxes.
    var boxesEl = grid.querySelector(".fbp-size-grid__boxes");
    boxesEl.innerHTML = "";
    for (var k = 0; k < cache.length; k++) {
      var item = cache[k];
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = SIZE_BOX_CLASS;
      btn.setAttribute("data-value", item.value);
      btn.textContent = item.displayText;
      if (item.soldOut) {
        btn.classList.add(SIZE_BOX_SOLDOUT);
        btn.setAttribute("aria-disabled", "true");
        btn.title = "Sold out";
      }
      if (item.value === currentValue) {
        btn.classList.add(SIZE_BOX_SELECTED);
        btn.setAttribute("aria-pressed", "true");
      }
      boxesEl.appendChild(btn);
    }
  }

  function updateAccessorySizeGrids() {
    if (!BELT_SIZE_GRID) return; // reuse the same feature flag
    var sections = getAccessorySections();
    for (var i = 0; i < sections.length; i++) {
      updateSizeGridInAccessoryTile(sections[i]);
    }
  }

  // Auto-select the first non-sold-out size on each accessory section,
  // exactly once per section per page load. Mirrors autoSelectBeltOnce.
  function autoSelectAccessoriesOnce() {
    var sections = getAccessorySections();
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      if (section._fbpAccessoryAutoSelectDone) continue;

      // Already selected? Mark done.
      if (section.querySelector('[class*="SelectedVariantsList"]')) {
        section._fbpAccessoryAutoSelectDone = true;
        continue;
      }

      var tile = getAccessoryTile(section);
      if (!tile) continue;

      var select =
        tile.querySelector('select[class*="variantSelector_container"]') ||
        tile.querySelector("select");
      if (!select || !select.options || !select.options.length) continue;

      var optionToPick = null;
      for (var j = 0; j < select.options.length; j++) {
        var opt = select.options[j];
        if (opt.value && opt.value !== "add" && !opt.disabled) {
          optionToPick = opt;
          break;
        }
      }
      if (!optionToPick) continue;

      setSelectValueReactSafe(select, optionToPick.value);
      section._fbpAccessoryAutoSelectDone = true;
      log("auto-selected accessory:", optionToPick.value);
    }
  }

  // ======================================================================
  // LEVER HEADER
  // ----------------------------------------------------------------------
  // Renders "Lever: <product name>" above the lever swatches, mirroring
  // the "Size: <name>" header on the belt size grid. Reads the currently
  // selected lever name from the lever section's SelectedVariantsList_title
  // text. Idempotent: safe to call on every rescan.
  // ======================================================================

  function updateLeverHeader() {
    var leverSection = getLeverSection();
    if (!leverSection) return;

    var items = leverSection.querySelector('[class*="style_collectionItems"]');
    if (!items) return;

    var header = leverSection.querySelector(".fbp-lever-header");
    if (!header) {
      header = document.createElement("div");
      header.className = "fbp-lever-header";
      header.appendChild(document.createTextNode("Lever: "));
      var val = document.createElement("span");
      val.className = "fbp-lever-header__current";
      header.appendChild(val);
      // Insert directly before the swatches container.
      items.parentNode.insertBefore(header, items);
    }

    var selectedList = leverSection.querySelector('[class*="SelectedVariantsList"]');
    var title = selectedList
      ? selectedList.querySelector('[class*="SelectedVariantsList_title"]')
      : null;
    var name = title ? (title.textContent || "").trim() : "";

    var valEl = header.querySelector(".fbp-lever-header__current");
    var nextText = name || "Select one";
    // Idempotent: only touch the DOM when the value actually changes.
    // Setting textContent unconditionally creates a new text node every
    // time, which fires our widget MutationObserver and can lead to
    // runaway rescan loops.
    if (valEl && valEl.textContent !== nextText) {
      valEl.textContent = nextText;
    }
  }

  // ======================================================================
  // LEVER PRICE DELTAS
  // ----------------------------------------------------------------------
  // Each lever tile renders an absolute price like "$28.00" inside a
  // <span class="style_price_…">. We replace that visual with a relative
  // "+$N" badge showing how much MORE this lever costs vs the cheapest
  // (non-sold-out) option. The cheapest tile gets nothing — no badge —
  // because "+$0" is noise.
  //
  // Implementation:
  //   • CSS hides the original [class*="style_price"] inside lever tiles
  //     (scoped via the data-fbp-lever-tile marker we set here).
  //   • For each tile we find the title <a>, then ensure a sibling span
  //     .fbp-lever-delta exists with the right text. Idempotent: only
  //     touches DOM when the value changes, to keep our own
  //     MutationObserver from re-triggering rescan in a loop.
  //
  // Format:
  //   • Whole dollars → "+$7"
  //   • Fractional   → "+$7.50"
  //   • Zero         → "" (badge hidden)
  // ======================================================================
  function fmtLeverDelta(n) {
    if (n <= 0) return "";
    var rounded = Math.round(n * 100) / 100;
    if (rounded === Math.floor(rounded)) return "+$" + rounded;
    return "+$" + rounded.toFixed(2);
  }
  function updateLeverPriceDeltas() {
    var leverSection = getLeverSection();
    if (!leverSection) return;
    var tiles = leverSection.querySelectorAll(
      '[class*="style_collectionItems"] > [class*="style_container"]'
    );
    if (!tiles.length) return;

    // Pass 1: read each tile's price and tag the tile so CSS can hide
    // the original price span.
    var rows = [];
    for (var i = 0; i < tiles.length; i++) {
      var tile = tiles[i];
      tile.setAttribute("data-fbp-lever-tile", "1");
      var priceEl = tile.querySelector('[class*="style_price"]');
      var rawText = priceEl ? (priceEl.textContent || "") : "";
      var num = parseFloat(rawText.replace(/[^0-9.]/g, ""));
      var soldOut = tile.classList.contains(SOLD_OUT_CLASS);
      rows.push({
        tile: tile,
        price: isNaN(num) ? null : num,
        soldOut: soldOut
      });
    }

    // Find the cheapest non-sold-out price as the baseline.
    var baseline = Infinity;
    for (var j = 0; j < rows.length; j++) {
      var r = rows[j];
      if (r.price != null && !r.soldOut && r.price < baseline) {
        baseline = r.price;
      }
    }
    if (!isFinite(baseline)) return; // every tile is sold out / unparseable

    // Pass 2: render the +$N badge on each tile.
    for (var k = 0; k < rows.length; k++) {
      var row = rows[k];
      if (row.price == null) continue;

      var titleLink = row.tile.querySelector("a");
      if (!titleLink) continue;

      var badge = row.tile.querySelector(".fbp-lever-delta");
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "fbp-lever-delta";
        // Insert immediately after the title link so it reads
        // "Silver Lever  +$7"
        titleLink.parentNode.insertBefore(badge, titleLink.nextSibling);
      }

      var deltaText = fmtLeverDelta(row.price - baseline);
      // Idempotent text update — see updateLeverHeader for why this
      // matters (avoids re-triggering our own MutationObserver).
      if (badge.textContent !== deltaText) {
        badge.textContent = deltaText;
      }
      // Also flip an attribute so CSS can hide the badge entirely
      // when empty (avoids leaving a stray empty span in the layout).
      var nextEmpty = deltaText === "" ? "1" : "0";
      if (badge.getAttribute("data-empty") !== nextEmpty) {
        badge.setAttribute("data-empty", nextEmpty);
      }
    }
  }

  /**
   * Pointer handler for size boxes — mirrors the lever radio-swap
   * pattern exactly.
   *
   * KEY DIFFERENCE FROM A NAIVE `click` HANDLER: we intercept at
   * pointerdown (and mousedown / touchstart) in the CAPTURE phase so
   * that Fast Bundle's own listeners never see the event. Running the
   * swap in `click` was too late — by the time click fires, Fast
   * Bundle has already started processing the interaction and Fast
   * Bundle's reconciliation logic treats a new variant change as an
   * ADD rather than a SWAP, leaving the old size in the cart.
   *
   * SelectedVariantsList is rendered INSIDE the belt tile on this
   * template; we look for it at the tile level first and fall back
   * to the belt section for safety.
   *
   * `_sizeSwapPending` de-duplicates the pointerdown/mousedown/
   * touchstart trio so we only run the swap orchestration once per
   * user interaction.
   */
  var _sizeSwapPending = false;
  function onSizeBoxPointerDown(e) {
    // Ignore non-primary buttons (right-click, middle-click, etc.)
    if (e.button !== undefined && e.button !== 0) return;

    var box = e.target.closest && e.target.closest("." + SIZE_BOX_CLASS);
    if (!box) return;

    // We're committed to handling this event — block Fast Bundle.
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    // Dedupe the pointerdown/mousedown/touchstart trio. This flag
    // clears when the swap completes (or times out).
    if (_sizeSwapPending) return;

    // Find the tile that contains this box. Works for the belt tile
    // AND accessory tiles (Power Stack knee sleeves + wrist wraps),
    // which all render their size grid inside their own product tile.
    var tile = box.closest(
      '[class*="style_collectionItems"] > [class*="style_container"]'
    );
    if (!tile) return;

    if (box.classList.contains(SIZE_BOX_SOLDOUT)) {
      log("blocked click on sold-out size");
      return;
    }
    if (box.classList.contains(SIZE_BOX_SELECTED)) return;

    var newValue = box.getAttribute("data-value");
    if (!newValue) return;

    // Derive the section this tile lives in — generic across belt +
    // accessory sections. Previously hardcoded to dividers[0].
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;
    var section = tile.closest('[class*="MainSection_divider"]');
    if (!section) return;

    // Prefer tile-scoped SelectedVariantsList (how this template
    // actually renders it); fall back to section-scoped query.
    var selectedList =
      tile.querySelector('[class*="SelectedVariantsList"]') ||
      section.querySelector('[class*="SelectedVariantsList"]');

    // ---- NO EXISTING SELECTION: just add ----
    if (!selectedList) {
      var s0 = getBeltSelect(tile);
      if (s0) {
        setSelectValueReactSafe(s0, newValue);
        log("added belt size (no prior):", newValue);
      }
      return;
    }

    // ---- EXISTING SELECTION: remove, then add ----
    var minusBtn = selectedList.querySelector(
      '[class*="SelectedVariantsList_minus"]'
    );
    if (!minusBtn) {
      // No minus button to click — best effort: just set new value.
      log("swap: minus button not found; falling back to bare add");
      var s1 = getBeltSelect(tile);
      if (s1) setSelectValueReactSafe(s1, newValue);
      return;
    }

    _sizeSwapPending = true;
    log("swapping belt size:", newValue);

    // Capture a "signature" of the current selection (its title text)
    // so we can poll for it going away — Fast Bundle sometimes updates
    // SelectedVariantsList IN PLACE instead of unmounting it when a
    // swap is in flight, so checking for container removal alone
    // causes waitForRemoval to time out. Checking that the title text
    // has changed OR the container is gone is much more reliable.
    var beforeTitleEl = selectedList.querySelector(
      '[class*="SelectedVariantsList_title"]'
    );
    var beforeTitle = beforeTitleEl ? (beforeTitleEl.textContent || "").trim() : "";

    // Belt-and-suspenders remove: first invoke React's onClick directly
    // (bypasses any event-dispatch weirdness) AND simulate a full click
    // (covers themes/apps that hooked native events instead of React).
    invokeReactOnClick(minusBtn);
    simulateFullClick(minusBtn);

    // Poll for confirmed removal: SVL is gone OR its title changed
    // (meaning Fast Bundle has finished committing the remove).
    var pollStart = Date.now();
    var POLL_MAX = 1200;
    var POLL_STEP = 50;
    function stepRemoval() {
      var stillSvl =
        tile.querySelector('[class*="SelectedVariantsList"]') ||
        section.querySelector('[class*="SelectedVariantsList"]');
      var titleChanged = false;
      if (stillSvl) {
        var t = stillSvl.querySelector('[class*="SelectedVariantsList_title"]');
        var now = t ? (t.textContent || "").trim() : "";
        if (beforeTitle && now && now !== beforeTitle) titleChanged = true;
      }
      var done = !stillSvl || titleChanged;

      if (done || Date.now() - pollStart >= POLL_MAX) {
        try {
          var s2 = getBeltSelect(tile);
          if (!s2) {
            log("swap: select vanished after removal");
          } else {
            setSelectValueReactSafe(s2, newValue);
            log("swapped belt size to:", newValue, "(removed=", !stillSvl, "titleChanged=", titleChanged, "elapsed=", Date.now() - pollStart, "ms)");
          }
        } finally {
          _sizeSwapPending = false;
        }
        return;
      }
      setTimeout(stepRemoval, POLL_STEP);
    }
    // Kick off the poll on the next tick so React has a chance to
    // commit the remove first.
    setTimeout(stepRemoval, POLL_STEP);

    // Safety: never strand the dedupe flag.
    setTimeout(function () {
      _sizeSwapPending = false;
    }, 2000);
  }

  /**
   * Sink the trailing `click` on our boxes so nothing further down
   * the chain (or Fast Bundle's bubbling listeners) sees it.
   */
  function onSizeBoxClickSink(e) {
    var box = e.target.closest && e.target.closest("." + SIZE_BOX_CLASS);
    if (!box) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
  }

  // NOTE: Size-box listeners are attached in attachWidgetListeners()
  // once we locate the widget element — NOT on `document`. A global
  // non-passive `touchstart` listener on document was causing iOS
  // Safari to stall taps on menu items and other controls outside
  // the bundle widget. Scoping listeners to the widget guarantees we
  // never touch events outside the bundle.

  /**
   * Throttled rescan: batches multiple rapid DOM mutations into a
   * single scan per animation frame.
   */
  var _rescanRaf = null;
  // Suppresses our own widget MutationObserver while we mutate the
  // widget from the rescan callbacks. Without this, every
  // updateLeverHeader / ensureFormFieldNames / updateBeltSizeGrid call
  // queues MO records for its own mutations, which re-schedules
  // another rescan on the next frame — a tight infinite loop that
  // burns CPU and starves the rest of the page (nav hover, mobile
  // tap handling, Add to Cart) of event-loop time.
  var _suppressMO = false;

  // ======================================================================
  // MIRROR BUNDLE PRICE TO THE TOP-OF-PAGE PRODUCT PRICE
  // ----------------------------------------------------------------------
  // Berlin's product__price element ("£95.00" under the title) renders
  // the belt's variant price and never updates when the user picks a
  // different lever. Fast Bundle, meanwhile, computes the live bundle
  // total (belt + selected lever) inside its widget at
  // [class*="cartInfoPrices_finalPrice"]. We hide that element via CSS
  // (Section 19) because it sits above Add to Cart in an ugly grey bar,
  // but its text content is still the source of truth for the running
  // total. This function reads that text and mirrors it to the top
  // product__price element on every rescan, so the top price updates
  // live as the user picks levers.
  //
  // Idempotent: only writes when the displayed value actually changes,
  // so we don't fire mutation events on the top price element.
  // ======================================================================
  function mirrorBundlePriceToTop() {
    // On Power Stack we don't mirror the live bundle total — the top
    // price is instead set to a deterministic per-lever sale/compare
    // pair by powerStackUpdateProductPrice(). See section below.
    // This preserves the existing Lever Belt behavior 100% (mirror
    // still runs there).
    if (document.body.classList.contains("fbp-power-stack")) return;

    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;
    var bundlePriceEl = widget.querySelector('[class*="cartInfoPrices_finalPrice"]');
    if (!bundlePriceEl) return;
    var bundleText = (bundlePriceEl.textContent || "").trim();
    if (!bundleText) return;

    // Berlin renders the top product price inside .product__price as a
    // <span class="price__regular ..."> element. Match defensively.
    var topPriceEl = document.querySelector(
      ".product__price .price__regular, .product__price [data-base-price]"
    );
    if (!topPriceEl) return;

    if (topPriceEl.textContent !== bundleText) {
      topPriceEl.textContent = bundleText;
    }
  }

  // ======================================================================
  // POWER STACK — LEVER-BASED PRODUCT PRICE OVERRIDE
  // ----------------------------------------------------------------------
  // On Power Stack product pages the top-of-page price (.product__price)
  // must display a specific sale + compare-at pair driven by which lever
  // the customer has selected in the Fast Bundle widget. Pricing spec:
  //
  //   Silver Lever / Black Lever                     → £148 sale / £175 comp
  //   Icon Silver Lever / Icon Black Lever           → £153 sale / £180 comp
  //   Stainless Steel 304 Silver / Black Lever       → £162 sale / £190 comp
  //
  // Match is by lever tile TITLE substring (not tile index), so if
  // Fast Bundle ever reorders the lever tiles the mapping still works.
  //
  // Scope: ONLY runs when body.fbp-power-stack is set AND the Fast
  // Bundle widget is present. Lever Belt pages (no fbp-power-stack)
  // and non-Fast-Bundle Power Stacks (no widget) are untouched.
  // ======================================================================
  var POWER_STACK_LEVER_PRICES = [
    // Order matters: most-specific patterns first.
    { match: /stainless/i, sale: 162, compare: 190 },
    { match: /icon/i,      sale: 153, compare: 180 }
  ];
  var POWER_STACK_DEFAULT_PRICE = { sale: 148, compare: 175 };

  function powerStackPriceForLever(name) {
    if (!name) return POWER_STACK_DEFAULT_PRICE;
    for (var i = 0; i < POWER_STACK_LEVER_PRICES.length; i++) {
      if (POWER_STACK_LEVER_PRICES[i].match.test(name)) {
        return POWER_STACK_LEVER_PRICES[i];
      }
    }
    return POWER_STACK_DEFAULT_PRICE;
  }

  function powerStackCurrentLeverName() {
    var section = getLeverSection();
    if (!section) return null;
    var tiles = section.querySelectorAll(
      '[class*="style_collectionItems"] > [class*="style_container"]'
    );
    for (var t = 0; t < tiles.length; t++) {
      if (tiles[t].querySelector('[class*="SelectedVariantsList"]')) {
        var titleEl = tiles[t].querySelector('[class*="style_productTitle"]');
        if (titleEl) return titleEl.textContent.trim();
      }
    }
    return null;
  }

  // 13mm Power Stacks (Blackout, and any future 13mm variant) carry a
  // flat sale/compare price regardless of which lever is selected. We
  // detect by matching the product H1 for the "13mm" (or "13 mm") token.
  // Any Power Stack whose title does NOT include "13mm" defaults to the
  // existing lever-based tier map (Silver/Black £148/£175, Icon
  // £153/£180, Stainless £162/£190).
  var POWER_STACK_13MM_PRICE = { sale: 182, compare: 215 };

  function powerStackIs13mm() {
    var h1 = document.querySelector("h1");
    if (!h1) return false;
    return /\b13\s*mm\b/i.test(h1.textContent || "");
  }

  function powerStackCurrentPrices() {
    if (powerStackIs13mm()) return POWER_STACK_13MM_PRICE;
    return powerStackPriceForLever(powerStackCurrentLeverName());
  }

  // Preserve whatever currency prefix the theme is already rendering
  // ("£", "$", "€", etc.) so a customer viewing in USD still sees
  // "$xxx.xx" — we just replace the numeric portion. If the current
  // text has no discernible prefix, fall back to "£" (storefront base).
  function powerStackFormatPrice(value, existingText) {
    var m = (existingText || "").match(/^([^\d\-\.]+)/);
    var prefix = m ? m[1] : "£";
    return prefix + value.toFixed(2);
  }

  // Suppression flag for our own writes so setupPowerStackPriceObserver
  // doesn't ping-pong on the mutations we cause.
  var _psPriceUpdateInProgress = false;

  function powerStackUpdateProductPrice() {
    if (!document.body.classList.contains("fbp-power-stack")) return;
    if (!document.getElementById(WIDGET_ID)) return;
    if (_psPriceUpdateInProgress) return;

    var priceWrap = document.querySelector(".product__price");
    if (!priceWrap) return;
    var priceContainer = priceWrap.querySelector(".price");
    var regularEl = priceWrap.querySelector(".price__regular");
    var compareEl = priceWrap.querySelector(".price__sale");
    if (!regularEl || !compareEl) return;

    // powerStackCurrentPrices() branches on 13mm-vs-10mm and, for 10mm,
    // reads the selected lever name. See helper above.
    var prices = powerStackCurrentPrices();

    var saleText = powerStackFormatPrice(prices.sale, regularEl.textContent);
    var compareText = powerStackFormatPrice(prices.compare, compareEl.textContent);
    var saleAttr = prices.sale.toFixed(2);
    var compareAttr = prices.compare.toFixed(2);

    var needsUpdate =
      regularEl.getAttribute("data-base-price") !== saleAttr ||
      compareEl.getAttribute("data-base-compare-price") !== compareAttr ||
      regularEl.textContent.trim() !== saleText ||
      compareEl.textContent.trim() !== compareText ||
      (priceContainer && !priceContainer.classList.contains("price--on-sale"));

    if (!needsUpdate) return;

    _psPriceUpdateInProgress = true;
    try {
      regularEl.setAttribute("data-base-price", saleAttr);
      compareEl.setAttribute("data-base-compare-price", compareAttr);
      regularEl.textContent = saleText;
      compareEl.textContent = compareText;
      if (priceContainer && !priceContainer.classList.contains("price--on-sale")) {
        priceContainer.classList.add("price--on-sale");
      }
    } finally {
      // Release on the next macrotask so mutations we just caused have
      // already been observed-and-ignored via the flag check.
      setTimeout(function () { _psPriceUpdateInProgress = false; }, 0);
    }
  }

  // Watch .product__price so if Berlin's variant-change JS or Shopify
  // currency conversion re-renders the price, we re-apply our lever
  // override. Guarded by _psPriceUpdateInProgress to avoid ping-pong.
  var _psPriceObserver = null;
  function setupPowerStackPriceObserver() {
    if (!document.body.classList.contains("fbp-power-stack")) return;
    if (_psPriceObserver) return;
    var priceWrap = document.querySelector(".product__price");
    if (!priceWrap) return;
    _psPriceObserver = new MutationObserver(function () {
      if (_psPriceUpdateInProgress) return;
      powerStackUpdateProductPrice();
    });
    _psPriceObserver.observe(priceWrap, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["data-base-price", "data-base-compare-price", "class"]
    });
  }

  function scheduleRescan() {
    if (_rescanRaf) return;
    _rescanRaf = requestAnimationFrame(function () {
      _rescanRaf = null;
      _suppressMO = true;
      try {
        scanForSoldOut();
        autoSelectBeltOnce();
        autoSelectLeverOnce();
        autoSelectAccessoriesOnce();
        updateBeltSizeGrid();
        updateAccessorySizeGrids();
        updateLeverHeader();
        updateLeverPriceDeltas();
        mirrorBundlePriceToTop();
        powerStackUpdateProductPrice();
        ensureFormFieldNames();
      } finally {
        // Setting to false via setTimeout(0) runs as a macrotask,
        // which fires AFTER the MO microtask has drained the records
        // from our own mutations. That way our rescan's mutations
        // are observed-and-ignored instead of re-triggering rescan.
        setTimeout(function () { _suppressMO = false; }, 0);
      }
    });
  }

  /**
   * Fast Bundle renders <select> elements without id or name
   * attributes, which triggers a Chrome DevTools Issues warning
   * ("A form field element should have an id or name attribute").
   * This is advisory only — nothing is broken — but we can silence
   * it by tagging each unnamed form element with a stable name/id
   * derived from its index. We use data-fbp-named so we don't
   * overwrite anything Fast Bundle may add later.
   */
  function ensureFormFieldNames() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;
    var fields = widget.querySelectorAll("select, input, textarea");
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.hasAttribute("data-fbp-named")) continue;
      if (!f.getAttribute("name") && !f.getAttribute("id")) {
        var base = "fbp-" + f.tagName.toLowerCase() + "-" + i;
        f.setAttribute("name", base);
        f.setAttribute("id", base);
      } else if (!f.getAttribute("name") && f.getAttribute("id")) {
        f.setAttribute("name", f.getAttribute("id"));
      } else if (!f.getAttribute("id") && f.getAttribute("name")) {
        f.setAttribute("id", f.getAttribute("name"));
      }
      f.setAttribute("data-fbp-named", "1");
    }
  }

  /**
   * Attach a MutationObserver to the widget so sold-out status
   * stays accurate as Fast Bundle re-renders (e.g. swapping a
   * <select> for a <div> when stock runs out, or vice versa).
   * Returns true once successfully attached.
   *
   * RACE GUARD: The MO alone isn't reliable during initial page load
   * because Fast Bundle may populate the widget synchronously before
   * we arm the observer (we've seen `dividers=0` on first scan and
   * then no subsequent mutations). We layer a short polling loop on
   * top: scheduleRescan runs every 200ms for up to 15 seconds, and
   * self-clears as soon as the belt is auto-selected AND the size
   * grid cache is populated. This is belt-and-suspenders.
   */
  function setupSoldOutWatcher() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return false;
    scanForSoldOut();
    autoSelectBeltOnce();
    autoSelectLeverOnce();
    autoSelectAccessoriesOnce();
    updateBeltSizeGrid();
    updateAccessorySizeGrids();
    updateLeverHeader();
    updateLeverPriceDeltas();
    mirrorBundlePriceToTop();
    powerStackUpdateProductPrice();
    setupPowerStackPriceObserver();
    ensureFormFieldNames();
    attachWidgetListeners(widget);
    var mo = new MutationObserver(function () {
      // Skip mutations caused by our own rescan pass — see _suppressMO.
      if (_suppressMO) return;
      scheduleRescan();
    });
    mo.observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-disabled", "class"]
    });
    log("sold-out watcher attached");

    // Dedicated observer for the bundle final-price text node.
    // The widget MO above is configured for childList / attributes but
    // NOT characterData — Fast Bundle updates the running total by
    // rewriting the text inside [class*="cartInfoPrices_finalPrice"]
    // without changing the child element structure, so pure text
    // mutations get missed. This observer watches that subtree with
    // characterData enabled and re-mirrors the price to the top of
    // the page on every change. Re-armed each time Fast Bundle
    // re-renders the price node (we re-query via setInterval below
    // because the element itself can be replaced by React).
    var _priceMo = null;
    var _priceMoTarget = null;
    function attachPriceMirror() {
      var priceEl = widget.querySelector('[class*="cartInfoPrices_finalPrice"]');
      if (!priceEl || priceEl === _priceMoTarget) return;
      if (_priceMo) _priceMo.disconnect();
      _priceMoTarget = priceEl;
      _priceMo = new MutationObserver(function () {
        // No suppress check needed — mirrorBundlePriceToTop only writes
        // to .product__price, which is OUTSIDE the FB widget, so it
        // can't loop the widget MO.
        mirrorBundlePriceToTop();
        // The bundle total changing is also our best signal that a
        // lever was just picked, so re-run the Power Stack override
        // (no-op on Lever Belt pages).
        powerStackUpdateProductPrice();
      });
      _priceMo.observe(priceEl, {
        characterData: true,
        childList: true,
        subtree: true
      });
      // Also fire once immediately to catch any pre-existing value.
      mirrorBundlePriceToTop();
      powerStackUpdateProductPrice();
    }
    attachPriceMirror();
    setInterval(attachPriceMirror, 1000);

    // Polling fallback for the initial-render race.
    var pollStart = Date.now();
    var POLL_MAX_MS = 15000;
    var POLL_INTERVAL_MS = 200;
    var pollId = setInterval(function () {
      var elapsed = Date.now() - pollStart;
      // Kick a rescan every tick so auto-select / grid / sold-out
      // status all get a chance to run regardless of MO events.
      scheduleRescan();
      // Exit conditions: we've done both one-shot auto-selects AND the
      // size grid cache has real data (or the relevant feature is off)
      // AND every lever tile has been tagged with data-fbp-lever-tile
      // (i.e. updateLeverPriceDeltas has had at least one successful pass
      // over the fully-rendered lever section). This last condition is
      // critical — without it, the polling can exit before Fast Bundle's
      // React render has populated all the lever swatches, leaving the
      // +$N badges missing on first page load.
      var beltReady = !AUTO_SELECT_BELT || _beltAutoSelectDone;
      var leverReady = !AUTO_SELECT_LEVER || _leverAutoSelectDone;
      var gridReady = !BELT_SIZE_GRID || (_beltSizeCache && _beltSizeCache.length > 0);
      var deltasReady = (function () {
        var section = getLeverSection();
        if (!section) return false;
        var tiles = section.querySelectorAll(
          '[class*="style_collectionItems"] > [class*="style_container"]'
        );
        if (!tiles.length) return false;
        var tagged = section.querySelectorAll("[data-fbp-lever-tile]").length;
        return tagged >= tiles.length;
      })();
      // Power Stack readiness: every accessory section has been auto-
      // selected AND has a populated size cache. Trivially true on the
      // Lever Belt page (no accessory sections).
      var accessoriesReady = (function () {
        var sections = getAccessorySections();
        if (!sections.length) return true;
        for (var ai = 0; ai < sections.length; ai++) {
          if (!sections[ai]._fbpAccessoryAutoSelectDone) return false;
          if (!sections[ai]._fbpSizes || !sections[ai]._fbpSizes.length) return false;
        }
        return true;
      })();
      if (beltReady && leverReady && gridReady && deltasReady && accessoriesReady) {
        log("init poll: ready after", elapsed, "ms — stopping poll");
        clearInterval(pollId);
        return;
      }
      if (elapsed >= POLL_MAX_MS) {
        log("init poll: timeout after", elapsed, "ms (beltReady=", beltReady, "leverReady=", leverReady, "gridReady=", gridReady, "deltasReady=", deltasReady, "accessoriesReady=", accessoriesReady, ")");
        clearInterval(pollId);
      }
    }, POLL_INTERVAL_MS);

    return true;
  }

  // The widget may not exist yet when this script runs. Try now;
  // if it's not ready, watch document.body until the widget appears.
  if (!setupSoldOutWatcher()) {
    var _bodyObs = new MutationObserver(function () {
      if (setupSoldOutWatcher()) _bodyObs.disconnect();
    });
    _bodyObs.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
    document.addEventListener("DOMContentLoaded", function () {
      if (setupSoldOutWatcher()) _bodyObs.disconnect();
    });
  }


  /**
   * Main click handler — runs in capture phase before Fast Bundle.
   *
   * Uses the same belt-and-suspenders pattern as the size grid:
   * invokeReactOnClick + simulateFullClick on the minus button, then a
   * polling loop that completes on EITHER container removal OR title-
   * text change (because Fast Bundle sometimes updates the
   * SelectedVariantsList in place instead of unmounting it).
   */
  var _leverSwapPending = false;
  var _simulating = false; // guards against our own synthetic events
                           // re-entering this handler via capture phase
  function onPointerDown(e) {
    // Skip our own simulated events so they can reach Fast Bundle.
    if (_simulating) return;

    // Ignore anything except primary button
    if (e.button !== undefined && e.button !== 0) return;

    var leverSection = getLeverSection();
    if (!leverSection || !leverSection.contains(e.target)) return;

    // Which tile (swatch) is being clicked?
    var tile = e.target.closest(
      '[class*="style_collectionItems"] > [class*="style_container"]'
    );
    if (!tile) return;

    // Sold-out? The marker class is maintained by scanForSoldOut()
    // below, which reliably identifies truly sold-out items by their
    // "Sold out" text content (something CSS cannot detect).
    if (tile.classList.contains(SOLD_OUT_CLASS)) {
      log("blocked click on sold-out lever");
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
      return;
    }

    // Clicking the already-selected lever? Let Fast Bundle handle it normally.
    if (tile.querySelector('[class*="SelectedVariantsList"]')) return;

    // Is another lever currently selected?
    var currentSelected = leverSection.querySelector('[class*="SelectedVariantsList"]');
    if (!currentSelected) {
      // FIRST-TIME ADD — on iOS Safari, taps on non-interactive <div>
      // tiles don't reliably synthesize `click`, so Fast Bundle's React
      // handler never runs and the lever is never added. We intercept
      // the pointerdown and trigger the add ourselves.
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
      if (_leverSwapPending) return;
      _leverSwapPending = true;

      // Preferred path: if the tile has a real <select>, drive it
      // (same approach as the proven-working belt auto-select + size
      // swap).
      var firstAddSelect =
        tile.querySelector('select[class*="variantSelector_container"]') ||
        tile.querySelector("select");
      if (firstAddSelect && firstAddSelect.options && firstAddSelect.options.length) {
        var firstAddOption = null;
        for (var fa = 0; fa < firstAddSelect.options.length; fa++) {
          var faOpt = firstAddSelect.options[fa];
          if (faOpt.value && faOpt.value !== "add") {
            firstAddOption = faOpt;
            break;
          }
        }
        if (firstAddOption) {
          setSelectValueReactSafe(firstAddSelect, firstAddOption.value);
          log("first-time add (via select):", firstAddOption.value);
          setTimeout(function () { _leverSwapPending = false; }, 500);
          return;
        }
      }

      // Fallback: no usable <select> on the tile yet (typical before
      // any variant is selected — Fast Bundle renders an "add" button
      // instead).
      //
      // Invoke EXACTLY ONE React onClick. Invoking more than one
      // causes Fast Bundle to add the variant multiple times (the
      // tile's outer onClick and its inner "add" button's onClick are
      // separate handlers). We prefer the first descendant with an
      // onClick (typically the inner "add" button — the most specific
      // handler), falling back to the tile itself only if no
      // descendant has one.
      var invokedEl = null;
      var cands = tile.querySelectorAll("*");
      for (var ci = 0; ci < cands.length; ci++) {
        if (invokeReactOnClick(cands[ci])) {
          invokedEl = cands[ci];
          break;
        }
      }
      if (!invokedEl && invokeReactOnClick(tile)) invokedEl = tile;

      if (!invokedEl) {
        // Last resort: no React onClick found anywhere in the tile.
        // Simulate a native click sequence on the tile.
        _simulating = true;
        try { simulateFullClick(tile); } finally {
          setTimeout(function () { _simulating = false; }, 0);
        }
      }

      log(
        "first-time add:",
        invokedEl
          ? "invoked onClick on " + invokedEl.tagName + (invokedEl.className ? " ." + (invokedEl.className + "").split(" ")[0] : "")
          : "no React onClick; simulated click on tile"
      );
      setTimeout(function () { _leverSwapPending = false; }, 500);
      return;
    }

    // There IS an existing selection: intercept the click entirely
    // so we can orchestrate remove-then-add in order.
    log("intercepting click to swap lever");
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    // Dedupe the pointerdown/mousedown/touchstart trio.
    if (_leverSwapPending) return;

    // The new lever's <select> — only present on variant products
    // (belts). For levers (no variants) Fast Bundle renders a <div>
    // instead, so newSelect will be null and we'll fall back to the
    // React onClick path below.
    var newSelect =
      tile.querySelector('select[class*="variantSelector_container"]') ||
      tile.querySelector("select");
    var hasRealSelect = !!(newSelect && newSelect.options && newSelect.options.length);

    // 1. Click the minus on the current selection to remove it
    var minusBtn = currentSelected.querySelector('[class*="SelectedVariantsList_minus"]');
    if (!minusBtn) {
      log("no minus button on current selection — aborting");
      return;
    }

    _leverSwapPending = true;

    // Capture the current SelectedVariantsList title so we can detect
    // Fast Bundle updating it IN PLACE (which defeats the simple
    // "container removed" signal).
    var beforeTitleEl = currentSelected.querySelector(
      '[class*="SelectedVariantsList_title"]'
    );
    var beforeTitle = beforeTitleEl ? (beforeTitleEl.textContent || "").trim() : "";

    // Belt-and-suspenders remove: invoke React's onClick directly AND
    // simulate a full click sequence, covering both pathways.
    invokeReactOnClick(minusBtn);
    _simulating = true;
    try { simulateFullClick(minusBtn); } finally {
      setTimeout(function () { _simulating = false; }, 0);
    }

    // Poll for confirmed removal: SVL is gone OR its title changed.
    var pollStart = Date.now();
    var POLL_MAX = 1200;
    var POLL_STEP = 50;
    function stepRemoval() {
      var stillSvl = leverSection.querySelector('[class*="SelectedVariantsList"]');
      var titleChanged = false;
      if (stillSvl) {
        var t = stillSvl.querySelector('[class*="SelectedVariantsList_title"]');
        var now = t ? (t.textContent || "").trim() : "";
        if (beforeTitle && now && now !== beforeTitle) titleChanged = true;
      }
      var done = !stillSvl || titleChanged;

      if (done || Date.now() - pollStart >= POLL_MAX) {
        try {
          if (hasRealSelect) {
            // Variant-product path: drive the <select>.
            var optionToPick = null;
            for (var i = 0; i < newSelect.options.length; i++) {
              var opt = newSelect.options[i];
              if (opt.value && opt.value !== "add") {
                optionToPick = opt;
                break;
              }
            }
            if (!optionToPick) {
              log("no selectable variant on new tile");
            } else {
              setSelectValueReactSafe(newSelect, optionToPick.value);
              log("swapped lever to:", optionToPick.value,
                  "(removed=", !stillSvl, "titleChanged=", titleChanged,
                  "elapsed=", Date.now() - pollStart, "ms)");
            }
          } else {
            // Non-variant path (levers): invoke ONE React onClick on
            // the new tile's subtree — same approach as first-time-add
            // for levers.
            var invokedSwap = null;
            var swapCands = tile.querySelectorAll("*");
            for (var sci = 0; sci < swapCands.length; sci++) {
              if (invokeReactOnClick(swapCands[sci])) {
                invokedSwap = swapCands[sci];
                break;
              }
            }
            if (!invokedSwap && invokeReactOnClick(tile)) invokedSwap = tile;
            if (!invokedSwap) {
              // Last resort: synthetic click
              _simulating = true;
              try { simulateFullClick(tile); } finally {
                setTimeout(function () { _simulating = false; }, 0);
              }
              log("swap (onClick fallback): no onClick found; simulated click on tile",
                  "(removed=", !stillSvl, "titleChanged=", titleChanged,
                  "elapsed=", Date.now() - pollStart, "ms)");
            } else {
              log("swap (onClick): invoked onClick on", invokedSwap.tagName,
                  "(removed=", !stillSvl, "titleChanged=", titleChanged,
                  "elapsed=", Date.now() - pollStart, "ms)");
            }
          }
        } finally {
          _leverSwapPending = false;
        }
        return;
      }
      setTimeout(stepRemoval, POLL_STEP);
    }
    setTimeout(stepRemoval, POLL_STEP);

    // Safety: never strand the dedupe flag.
    setTimeout(function () {
      _leverSwapPending = false;
    }, 2000);
  }

  // Lever listeners are attached in attachWidgetListeners() alongside
  // the size-box listeners. Both are scoped to the widget element so
  // taps outside the bundle (menu, site nav, etc.) are never
  // intercepted — fixes an iOS Safari issue where non-passive
  // document-level touchstart listeners froze all taps on the page.

  // ======================================================================
  // WIDGET-SCOPED LISTENER ATTACHMENT
  // ----------------------------------------------------------------------
  // Attaches all capture-phase listeners to the widget element exactly
  // once. Safe to call repeatedly; the flag prevents duplicates.
  // ======================================================================
  var _listenersAttached = false;
  function attachWidgetListeners(widget) {
    if (_listenersAttached || !widget) return;
    _listenersAttached = true;

    // Size-box handlers.
    //
    // touchstart is registered as PASSIVE. Non-passive touchstart on an
    // ancestor is a known iOS Safari footgun: it can suppress click
    // synthesis even when preventDefault is never called, which was
    // killing lever taps on mobile. We don't need preventDefault on
    // touchstart — our logic blocks Fast Bundle via pointerdown/
    // mousedown preventDefault (both still non-passive by default) and
    // via stopImmediatePropagation on the click path.
    widget.addEventListener("pointerdown", onSizeBoxPointerDown, true);
    widget.addEventListener("mousedown", onSizeBoxPointerDown, true);
    widget.addEventListener("touchstart", onSizeBoxPointerDown, { capture: true, passive: true });
    widget.addEventListener("click", onSizeBoxClickSink, true);

    // Lever-tile handlers (same passive-touchstart reasoning as above).
    widget.addEventListener("pointerdown", onPointerDown, true);
    widget.addEventListener("mousedown", onPointerDown, true);
    widget.addEventListener("touchstart", onPointerDown, { capture: true, passive: true });

    log("widget listeners attached");
  }

  log("installed");
})();


/* =================================================================
   Product Page Layout Reorder — Mix & Match Lever Belt
   Berlin Theme
   -----------------------------------------------------------------
   Desired visual order inside .product__info:
      Title
      Rating
      Price
      >>> PL swatches (Platmart Swatches app)          <<<
      >>> Belt size grid (Fast Bundle)                 <<<
      >>> Lever selection (Fast Bundle)                <<<
      Buy buttons
      ...rest
   -----------------------------------------------------------------
   WHAT THIS SCRIPT DOES
   1. Waits for both the Fast Bundle widget (#rbr-container-element-true)
      and the Platmart Swatches element (.pl-swatches) to render.
   2. Moves .pl-swatches into .product__info, immediately before the
      Fast Bundle widget.
   3. If .pl-swatches was hidden with display:none, unhides it.
   4. Re-runs on Shopify section re-renders (quick view, variant
      changes that re-paint the widget, etc.).
   -----------------------------------------------------------------
   WHERE TO PASTE THIS
   Shopify admin → Online Store → Themes → Edit code
     → Assets → create file: product-layout-reorder.js
     → paste this whole file
     → then in snippets/product-lever-belt.liquid (or your custom
       product template) add near the top:
         <script src="{{ 'product-layout-reorder.js' | asset_url }}" defer></script>
   ================================================================= */

(function () {
  'use strict';

  // Only run on product pages that have both the Fast Bundle widget
  // AND a .product__info column. This avoids touching collection/cart.
  var FB_SELECTOR = '#rbr-container-element-true';
  var PL_SELECTOR = '.pl-swatches';
  var INFO_SELECTOR = '.product__info, .product-information, product-info';

  var moved = false;

  function findProductInfo() {
    // Berlin uses .product__info; other themes may use variants.
    var candidates = document.querySelectorAll(INFO_SELECTOR);
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].querySelector(FB_SELECTOR)) return candidates[i];
    }
    return null;
  }

  function doReorder() {
    var fb = document.querySelector(FB_SELECTOR);
    var pl = document.querySelector(PL_SELECTOR);
    if (!fb || !pl) return false;

    var info = findProductInfo();
    if (!info) return false;

    // The Fast Bundle widget is nested inside .product__price. We want
    // the PL swatches to sit in the main .product__info column, directly
    // ABOVE the .product__price block (so the order becomes
    // price → pl-swatches → fast bundle is not quite what we want;
    // we actually want price, then swatches, then fast bundle).
    //
    // Because Fast Bundle sits inside .product__price as a sibling of
    // the price number itself, the cleanest move is to place .pl-swatches
    // directly before #rbr-container-element-true inside its parent.
    var fbParent = fb.parentNode;
    if (!fbParent) return false;

    // Avoid re-parenting if already in the right spot.
    if (pl.previousElementSibling === null && pl.parentNode === fbParent) {
      // already a direct child, but not necessarily in the right position
    }
    if (pl.nextElementSibling === fb && pl.parentNode === fbParent) {
      // already sitting right before the Fast Bundle widget — done.
      return true;
    }

    try {
      fbParent.insertBefore(pl, fb);
    } catch (e) {
      return false;
    }

    // Unhide if Platmart's render function left it display:none.
    // (It should be visible once it's in the right DOM location.)
    if (getComputedStyle(pl).display === 'none') {
      pl.style.display = '';
    }
    pl.removeAttribute('hidden');

    // Tag so our CSS can target the new location.
    pl.setAttribute('data-relocated', 'true');

    moved = true;
    return true;
  }

  // Quick check: is pl-swatches already sitting right before the Fast
  // Bundle widget in the same parent? Used to bail out cheaply on
  // mutation observer ticks where nothing relevant changed.
  function isInPlace() {
    var fb = document.querySelector(FB_SELECTOR);
    var pl = document.querySelector(PL_SELECTOR);
    if (!fb || !pl) return false;
    return pl.nextElementSibling === fb && pl.parentNode === fb.parentNode;
  }

  // Persistent polling. We used to stop the interval as soon as
  // doReorder returned true (i.e., the swatches were in the right
  // place ONCE). That was fragile: anything that triggered Platmart
  // Swatches to re-render later in the lifecycle (e.g., the lever
  // auto-select firing a Shopify variant event that Platmart listens
  // to) would re-mount .pl-swatches at its original position in
  // .product__variants, which appears BELOW .product__price visually.
  //
  // Now we keep polling at 100ms for the full 30s window — doReorder
  // is idempotent and cheap, and isInPlace() bails out immediately
  // when nothing needs fixing. This catches any late re-render the
  // MutationObserver below might miss.
  function startLoop() {
    var tries = 0;
    var MAX_TRIES = 300; // ~30 seconds at 100ms
    var iv = setInterval(function () {
      tries++;
      if (!isInPlace()) doReorder();
      if (tries >= MAX_TRIES) clearInterval(iv);
    }, 100);
  }

  // Aggressive observer: any DOM mutation anywhere in the document
  // can be a trigger to re-check, but we bail out immediately if
  // pl-swatches is already in the right place (cheap selector + two
  // ref comparisons). The _reorderPending flag prevents our own
  // insertBefore from re-entering the observer in a tight loop.
  function installObserver() {
    var target = document.body;
    if (!target || typeof MutationObserver !== 'function') return;

    var _reorderPending = false;
    var mo = new MutationObserver(function () {
      if (_reorderPending) return;
      if (isInPlace()) return;
      // Defer the actual move to the next animation frame so all
      // pending mutations from this batch settle first. Without this
      // we sometimes raced Platmart's render and ended up moving a
      // stale node.
      _reorderPending = true;
      requestAnimationFrame(function () {
        try { doReorder(); } finally { _reorderPending = false; }
      });
    });
    mo.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startLoop();
      installObserver();
    });
  } else {
    startLoop();
    installObserver();
  }

  // Re-run on Shopify theme editor section events.
  document.addEventListener('shopify:section:load', doReorder);
  document.addEventListener('shopify:section:reorder', doReorder);
})();

/* =====================================================================
   UpCart × Berlin cart-drawer scroll-lock reconciler
   ---------------------------------------------------------------------
   Bug this fixes:
     When an item is added to the cart, TWO drawer systems fire:
       1. Berlin theme opens its native <cart-drawer> silently in the
          background and sets body.has-modal-opening (which applies
          overflow:hidden to <body>).
       2. UpCart intercepts and shows its own popup, adding
          body.upcartPopupShow (also overflow:hidden).
     When the user closes UpCart, UpCart cleans up its own class, but
     Berlin's has-modal-opening stays behind because Berlin never
     "knew" its drawer was visually suppressed. Result: body remains
     overflow:hidden and the page cannot scroll on either desktop or
     mobile until a hard refresh.

   What this reconciler does:
     Watches body class changes. Whenever UpCart's class is absent
     AND Berlin's has-modal-opening is present AND Berlin's
     <cart-drawer> is not actually visible (display:none), it strips
     has-modal-opening off <body> and clears the residual open/visible
     attributes on <cart-drawer>. This restores the natural scroll
     behavior without touching either app's own drawer flows.
   ===================================================================== */
(function () {
  "use strict";

  var LOCK_CLASS = 'has-modal-opening';
  var UPCART_CLASS = 'upcartPopupShow';

  function drawerIsVisible(drawer) {
    if (!drawer) return false;
    try {
      var cs = window.getComputedStyle(drawer);
      if (!cs) return false;
      // Berlin toggles display:none <-> display:block/flex when the
      // drawer actually opens. If display is 'none', the drawer is
      // not on screen even if the [open] attribute is present.
      if (cs.display === 'none') return false;
      if (cs.visibility === 'hidden') return false;
      if (parseFloat(cs.opacity) === 0) return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  function reconcile() {
    var body = document.body;
    if (!body) return;

    // If UpCart's popup is currently up, do nothing. UpCart owns the
    // scroll-lock during its own lifecycle.
    if (body.classList.contains(UPCART_CLASS)) return;

    // If Berlin's lock class isn't set, there's nothing to reconcile.
    if (!body.classList.contains(LOCK_CLASS)) return;

    // If Berlin's cart-drawer is genuinely on screen, respect it —
    // this reconciler must never yank scroll back while a real drawer
    // (or any other modal that uses the same class) is visible.
    var drawer = document.querySelector('cart-drawer');
    if (drawerIsVisible(drawer)) return;

    // Any other Berlin modal that legitimately uses has-modal-opening?
    // Berlin sets this class for cart-drawer and for its generic
    // <modal-dialog open> pattern. If any modal-dialog is open,
    // leave things alone.
    var openDialog = document.querySelector('modal-dialog[open], dialog[open]');
    if (openDialog) {
      var dcs = window.getComputedStyle(openDialog);
      if (dcs && dcs.display !== 'none') return;
    }

    // Safe to unlock.
    body.classList.remove(LOCK_CLASS);
    if (drawer) {
      drawer.removeAttribute('open');
      drawer.removeAttribute('visible');
    }
  }

  function init() {
    // Run once in case we loaded mid-broken-state.
    reconcile();

    if (typeof MutationObserver !== 'function') return;

    // Watch body class flips. This catches:
    //   - upcartPopupShow being removed (UpCart closing)
    //   - has-modal-opening being added by Berlin silently
    var bodyObserver = new MutationObserver(function () {
      reconcile();
    });
    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Also watch cart-drawer attribute changes so we notice when
    // Berlin toggles [open]/[visible] without the body class flipping.
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var drawerObserver = new MutationObserver(function () {
        reconcile();
      });
      drawerObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['open', 'visible', 'style', 'class']
      });
    }

    // Belt-and-suspenders: any click that dismisses UpCart lives
    // outside our observer path if UpCart batches DOM updates, so
    // run one more reconcile a beat after any body-level click.
    document.addEventListener('click', function () {
      // Wait for UpCart's own teardown to finish before we check.
      setTimeout(reconcile, 50);
      setTimeout(reconcile, 300);
    }, true);

    // Also reconcile on ESC (a common close-drawer key).
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        setTimeout(reconcile, 50);
        setTimeout(reconcile, 300);
      }
    }, true);
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();


/* =====================================================================
   LEVER BELT PAGE — TOP PRICE PREEMPT (glitch fix)
   ---------------------------------------------------------------------
   Symptom: on lever belt product pages the top price momentarily goes
   blank / flashes the belt-only base value (e.g. "$105.00") before
   settling on the correct bundle total (e.g. "$140.00"). Shows up
   both on initial page load and on any lever swatch/tile selection.

   Root cause: TWO independent code paths can write the top price
   element (`.price__regular.product-price-wrapper`), and neither
   reliably lands on the right value fast enough:

     A) Fast Bundle build (mix-match product page):
        - Fast Bundle renders its widget with a running total in
          `[class*="cartInfoPrices_finalPrice"]`.
        - `mirrorBundlePriceToTop()` (elsewhere in this file) copies
          that total into `.price__regular` via a MutationObserver on
          the bundle price element.
        - BUT: Berlin's `<variant-picker>` component reacts to
          Shopify variant-change events by clearing / rewriting
          `.price__regular` — and the mirror observer only fires when
          the *bundle* price changes, so a variant-change that leaves
          the bundle total the same still leaves the top price wiped.

     B) Direct-product build (`/products/lever-belt-...` page):
        - Server renders `.price__regular` = base price ($105) with
          `data-base-price="105.00"`.
        - The Platmart swatches app (mak.js) writes `base + selected
          lever's [data-price]` into `.price__regular` on load and
          on click. That write happens AFTER Platmart's script
          initializes, so the page paints $105 first and then flashes
          to $140. On subsequent clicks Platmart briefly resets the
          value before rewriting.

   Fix strategy — a top-level correction observer that runs
   synchronously as a microtask (i.e. before the next paint) so no
   wrong value is ever visible on screen:

     1) Load-time preempt: on script parse (before DOMContentLoaded
        even, if possible), on DOMContentLoaded, on window.load, and
        on a short RAF/timeout ladder, compute the correct total
        (via the strategy that applies — Fast Bundle bundle total
        OR base + active-swatch price) and write it into
        `.price__regular`. Kills the initial-render flash.

     2) Click-time preempt: capture-phase click listener on lever
        swatches or lever tiles computes `base + tile.[data-price]`
        and writes it synchronously BEFORE any bubble-phase handler
        runs.

     3) Correction observer: MutationObserver on `.price__regular`.
        Any mutation that lands a value other than the correct total
        is corrected in the same microtask, before paint.

   The observer callback picks whichever price source applies:
     - If a Fast Bundle bundle total element is present and has a
       non-empty value, use that.
     - Else if Platmart swatch tiles are present, use base + the
       currently-active tile's [data-price].
     - Else, do nothing (no source to derive the total from).

   Scope: gated on `body.fbp-lever-belt` so Power Stack and every
   other product page is untouched. Power Stack pricing is handled
   separately by `powerStackUpdateProductPrice()` above.
   ===================================================================== */
(function () {
  "use strict";

  // ---- Selectors -----------------------------------------------------
  var TOP_PRICE_SELECTOR =
    '.product__price .price__regular, .product__price [data-base-price]';
  // Fast Bundle's running total inside its widget
  var BUNDLE_TOTAL_SELECTOR = '[class*="cartInfoPrices_finalPrice"]';
  // Platmart swatch tiles + their per-lever [data-price] payload
  var PM_TILE_SELECTOR = '.mar-prod-box.mak-lever-pdp';
  var PM_TILE_PRICE_SELECTOR = '[data-price]';
  var PM_ACTIVE_CLASS = 'mar-top-active';
  // In-widget lever tile (Fast Bundle build) marked as selected
  var FB_TILE_SELECTOR =
    '[class*="style_collectionItems"] > [class*="style_container"]';
  var FB_SELECTED_MARK_SELECTOR = '[class*="SelectedVariantsList"]';

  // ---- Reentrance guards --------------------------------------------
  // True while we ourselves are writing to the top price node, so our
  // own correction observer ignores the resulting mutation record.
  var _writing = false;

  // ---- Small helpers ------------------------------------------------
  function isLeverBeltPage() {
    return document.body &&
      document.body.classList.contains('fbp-lever-belt');
  }

  // Parse "$35.00", "$35", "£35.00", " USD 35 " → 35 (Number).
  function parseMoney(str) {
    if (str == null) return NaN;
    var m = String(str).match(/-?\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  // Preserve the currency prefix (Shopify currency switcher may
  // change it at runtime). Fallback: "$".
  function formatMoney(value, existingText) {
    var m = (existingText || '').match(/^([^\d\-\.]+)/);
    var prefix = m ? m[1] : '$';
    return prefix + value.toFixed(2);
  }

  function getTopPriceEl() {
    return document.querySelector(TOP_PRICE_SELECTOR);
  }

  function getBaseFromPriceEl(priceEl) {
    if (!priceEl) return NaN;
    var v = parseMoney(priceEl.getAttribute('data-base-price'));
    if (!isNaN(v)) return v;
    // Fallback: derive from current text if attribute missing.
    return parseMoney(priceEl.textContent);
  }

  // ---- Source A: Fast Bundle bundle total ---------------------------
  function fastBundleTotal() {
    var el = document.querySelector(BUNDLE_TOTAL_SELECTOR);
    if (!el) return null;
    var txt = (el.textContent || '').trim();
    if (!txt) return null;
    var n = parseMoney(txt);
    return isNaN(n) ? null : { value: n, source: 'fastbundle', text: txt };
  }

  // ---- Source B: Platmart swatch tile with base + lever add-on ------
  function platmartTotal() {
    var tile = document.querySelector(
      PM_TILE_SELECTOR + '.' + PM_ACTIVE_CLASS
    );
    if (!tile) return null;
    var priceEl = tile.querySelector(PM_TILE_PRICE_SELECTOR);
    if (!priceEl) return null;
    var lp = parseMoney(priceEl.getAttribute('data-price'));
    if (isNaN(lp)) return null;
    var base = getBaseFromPriceEl(getTopPriceEl());
    if (isNaN(base)) return null;
    return { value: base + lp, source: 'platmart' };
  }

  // Prefer Fast Bundle (has the authoritative bundle total). Fall back
  // to Platmart tile math if the FB widget isn't rendered on this page.
  function computeTargetTotal() {
    return fastBundleTotal() || platmartTotal();
  }

  // Try to derive a lever price for the tile the customer just clicked
  // (either shape). Returns { leverPrice, base } or null. Used only by
  // the click preempt path — the correction observer prefers the FB
  // running total when it's available.
  function tileClickInfo(tile) {
    if (!tile) return null;
    var priceEl = tile.querySelector(PM_TILE_PRICE_SELECTOR);
    var lp = priceEl ? parseMoney(priceEl.getAttribute('data-price')) : NaN;
    if (isNaN(lp)) {
      // Fast Bundle tile shape: look for the tile's own product price
      var pEl = tile.querySelector('[class*="style_price"]');
      if (pEl) lp = parseMoney(pEl.textContent);
    }
    var base = getBaseFromPriceEl(getTopPriceEl());
    if (isNaN(lp) || isNaN(base)) return null;
    return { leverPrice: lp, base: base, value: base + lp };
  }

  // Mark the price element as "ready" so CSS reveals it. Idempotent —
  // once ready, the class stays put; subsequent writes just update
  // the visible number without any hide/show flicker.
  function markReady(priceEl) {
    priceEl = priceEl || getTopPriceEl();
    if (!priceEl) return;
    if (!priceEl.classList.contains('hb-price-ready')) {
      priceEl.classList.add('hb-price-ready');
    }
  }

  function hideNow(priceEl) {
    priceEl = priceEl || getTopPriceEl();
    if (!priceEl) return;
    priceEl.classList.remove('hb-price-ready');
  }

  // On mobile / slow initialization, Fast Bundle can walk the top
  // price through a sequence of intermediate values before landing on
  // the true bundle total (e.g. $0 → $105 → $140). Revealing on the
  // first write shows each of those. Instead we schedule a "reveal"
  // for STABILITY_MS after the most recent write; every new write
  // resets the timer. The user sees the price appear exactly once,
  // with the final value.
  var STABILITY_MS = 250;
  var _stabilityTimer = null;
  function scheduleReveal(priceEl) {
    priceEl = priceEl || getTopPriceEl();
    if (!priceEl) return;
    if (_stabilityTimer) clearTimeout(_stabilityTimer);
    _stabilityTimer = setTimeout(function () {
      _stabilityTimer = null;
      markReady(priceEl);
    }, STABILITY_MS);
  }

  // ---- Write path ---------------------------------------------------
  // Writes the numeric value into the top price element and reveals.
  //
  // Reveal modes:
  //   'stable' (default) — schedule the reveal STABILITY_MS after the
  //      last write. Used for load / observer paths where Fast Bundle
  //      may walk the price through several intermediate values (e.g.
  //      $0 → $105 → $140 on mobile). The stability window collapses
  //      the sequence into a single final reveal.
  //   'immediate' — reveal in the same JS turn as the write. Used on
  //      the click-time fast path where we've already computed the
  //      correct final total from tile data; delaying would just add
  //      perceived latency between the swatch click and the price
  //      update.
  function writeTop(value, priceEl, revealMode) {
    priceEl = priceEl || getTopPriceEl();
    if (!priceEl) return;
    var wanted = formatMoney(value, priceEl.textContent);
    if ((priceEl.textContent || '').trim() !== wanted) {
      _writing = true;
      try {
        priceEl.textContent = wanted;
      } finally {
        // Release on next macrotask so the mutation record from our
        // own write has already been observed-and-ignored via
        // _writing.
        setTimeout(function () { _writing = false; }, 0);
      }
    }
    if (revealMode === 'immediate') {
      // Cancel any pending stable-reveal timer — we're revealing now.
      if (_stabilityTimer) {
        clearTimeout(_stabilityTimer);
        _stabilityTimer = null;
      }
      markReady(priceEl);
    } else {
      scheduleReveal(priceEl);
    }
  }

  function preempt() {
    if (!isLeverBeltPage()) return;
    var t = computeTargetTotal();
    if (!t) return;
    writeTop(t.value);
  }

  // Try harder to compute the correct total at click time by looking
  // for a belt-tile inside the Fast Bundle widget (its price span is
  // the true belt base — `data-base-price` on the top price element
  // is unreliable on FB pages because FB may have already stamped
  // the current bundle total onto it).
  //
  // Returns { value } for `belt + clicked-lever` or null if we can't
  // establish both prices confidently.
  function clickTimeTotal(tile) {
    if (!tile) return null;

    // FB widget path: find the belt tile in the same widget and sum.
    var widget = tile.closest && tile.closest('[class*="CmmBap_container"]');
    if (widget) {
      var beltTile = null;
      var beltTiles = widget.querySelectorAll(FB_TILE_SELECTOR);
      for (var i = 0; i < beltTiles.length; i++) {
        var tt = beltTiles[i].querySelector('[class*="style_productTitle"]');
        if (tt && /\bbelt\b/i.test(tt.textContent || '')) {
          beltTile = beltTiles[i];
          break;
        }
      }
      var clickedPriceEl = tile.querySelector('[class*="style_price"]');
      var clickedPrice = clickedPriceEl
        ? parseMoney(clickedPriceEl.textContent)
        : NaN;

      // If the user clicked the belt tile itself, keep the currently
      // selected lever price and just refresh — don't try to guess.
      if (beltTile && tile === beltTile) return null;

      if (beltTile) {
        var bp = beltTile.querySelector('[class*="style_price"]');
        var beltPrice = bp ? parseMoney(bp.textContent) : NaN;
        if (!isNaN(beltPrice) && !isNaN(clickedPrice)) {
          return { value: beltPrice + clickedPrice };
        }
      }
    }

    // Platmart path: belt price = data-base-price on top price el,
    // add-on = clicked tile's [data-price] attribute.
    var pmPriceEl = tile.querySelector(PM_TILE_PRICE_SELECTOR);
    var pmLever = pmPriceEl
      ? parseMoney(pmPriceEl.getAttribute('data-price'))
      : NaN;
    var pmBase = getBaseFromPriceEl(getTopPriceEl());
    if (!isNaN(pmLever) && !isNaN(pmBase)) {
      return { value: pmBase + pmLever };
    }
    return null;
  }

  // ---- Capture-phase click preempt ----------------------------------
  // On any lever-tile click:
  //   1. Immediately hide the top price by removing .hb-price-ready —
  //      the CSS `:not(.hb-price-ready)` rule takes it out of view.
  //   2. Try to compute the correct new total at click time (via
  //      `clickTimeTotal`). If successful, write it and re-mark ready
  //      in the same JS turn, so the browser paints the NEW total
  //      without ever showing an in-between "original" value.
  //   3. If we can't compute yet (e.g. Fast Bundle hasn't hydrated
  //      the source data), poll on requestAnimationFrame until the
  //      correct total becomes available, then reveal. Cap at ~30
  //      frames (~500ms) so we never leave the price hidden forever.
  //
  // Net effect for the user: click a swatch → new price appears
  // instantly. No lingering old value, no wrong intermediate.
  function onDocClick(e) {
    if (!isLeverBeltPage()) return;
    if (!e.target || !e.target.closest) return;
    var tile = e.target.closest(PM_TILE_SELECTOR + ', ' + FB_TILE_SELECTOR);
    if (!tile) return;

    var priceEl = getTopPriceEl();
    if (!priceEl) return;

    // Hide first — before any competing code writes an intermediate
    // value the user could see.
    priceEl.classList.remove('hb-price-ready');

    // Fast path: compute at click time and reveal immediately — no
    // stability delay, so the user sees the new price the instant
    // they tap the swatch.
    var info = clickTimeTotal(tile);
    if (info) {
      writeTop(info.value, priceEl, 'immediate');
      return;
    }

    // Slow path: poll for the source data (Fast Bundle re-computing
    // its bundle total, Platmart flipping .mar-top-active on the new
    // tile) and reveal as soon as we can compute a value different
    // from what was showing before the click.
    var attempts = 0;
    var pollTotal = null;
    (function pollForTotal() {
      attempts++;
      var t = computeTargetTotal();
      if (pollTotal === null) pollTotal = t ? t.value : null;
      if (t && t.value !== pollTotal) {
        // Post-click write from a source (Fast Bundle bundle total) —
        // reveal immediately, no stability delay. The click already
        // committed the user to a new value; further updates from
        // FB should overwrite in place without hiding again.
        writeTop(t.value, priceEl, 'immediate');
        return;
      }
      if (attempts < 30) {
        requestAnimationFrame(pollForTotal);
      } else {
        // Give up gracefully — reveal whatever's there so the price
        // isn't left permanently hidden by a stalled Fast Bundle.
        scheduleReveal(priceEl);
      }
    })();
  }

  // ---- Correction observer on the top price -------------------------
  // If ANY code path writes the wrong value to `.price__regular`, we
  // correct it immediately. MO callbacks are microtasks — they drain
  // before paint — so the wrong value never actually reaches the
  // screen.
  var _correctionObs = null;
  function setupCorrectionObs() {
    if (_correctionObs) return;
    var priceEl = getTopPriceEl();
    if (!priceEl) return;
    _correctionObs = new MutationObserver(function () {
      if (_writing) return;
      if (!isLeverBeltPage()) return;
      var t = computeTargetTotal();
      if (!t) return;
      var wanted = formatMoney(t.value, priceEl.textContent);
      if ((priceEl.textContent || '').trim() !== wanted) {
        writeTop(t.value, priceEl);
      }
    });
    _correctionObs.observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // ---- Bundle-total observer ----------------------------------------
  // Also watch the Fast Bundle running total — whenever IT changes,
  // sync the top price. Existing mirrorBundlePriceToTop() already does
  // this on the same signal, but running it here again is idempotent
  // and closes a race where the bundle total changes but the top
  // observer above misses the write (e.g. if Berlin swapped the
  // .price__regular node between observations).
  var _bundleObs = null;
  var _bundleObsTarget = null;
  function attachBundleObs() {
    var el = document.querySelector(BUNDLE_TOTAL_SELECTOR);
    if (!el || el === _bundleObsTarget) return;
    if (_bundleObs) _bundleObs.disconnect();
    _bundleObsTarget = el;
    _bundleObs = new MutationObserver(function () { preempt(); });
    _bundleObs.observe(el, {
      childList: true, subtree: true, characterData: true
    });
    preempt();
  }

  // ---- Init ---------------------------------------------------------
  function init() {
    if (!isLeverBeltPage()) return;
    preempt();
    setupCorrectionObs();
    attachBundleObs();
    // Fast Bundle can re-mount its widget (React re-render) and swap
    // the bundle total element out from under us. Re-arm the bundle
    // observer periodically. Cheap, since it's a no-op once the
    // element identity is stable.
    setInterval(attachBundleObs, 1000);
    // Also retry preempt on a short ladder in case some source
    // (Fast Bundle bundle total, Platmart tile) isn't ready yet.
    requestAnimationFrame(preempt);
    setTimeout(preempt, 100);
    setTimeout(preempt, 400);
    setTimeout(preempt, 1200);

    // Safety net: if a broken Fast Bundle / Platmart never wires up,
    // reveal the price after 5s so the customer isn't staring at a
    // permanent blank. Whatever the server rendered will show, which
    // is better than nothing.
    setTimeout(function () {
      var priceEl = getTopPriceEl();
      if (priceEl) markReady(priceEl);
    }, 5000);
  }

  // Kick off as early as possible. If body already exists we start
  // immediately; otherwise wait for DOMContentLoaded. Also re-run on
  // 'load' in case Fast Bundle / Platmart hydrate late.
  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  window.addEventListener('load', function () {
    init();
    preempt();
  });
  // Capture-phase click listener attaches at document level so it
  // catches clicks regardless of tile shape (Fast Bundle vs Platmart).
  document.addEventListener('click', onDocClick, true);
})();